export interface IAuDateRangePeriods {
	start: Date;
	end: Date;
}

export class DateRangePeriods {
	periodToday: IAuDateRangePeriods;
	periodThisWeek: IAuDateRangePeriods;
	periodThisMonth: IAuDateRangePeriods;
	periodThisYear: IAuDateRangePeriods;

	constructor() {
		const today = new Date();
		this.periodToday = {
			start: today,
			end: today,
		};

		// This week (starting on Monday)
		const startOfWeek = new Date(today);
		startOfWeek.setDate(today.getDate() - ((today.getDay() + 6) % 7));

		const endOfWeek = new Date(startOfWeek);
		endOfWeek.setDate(startOfWeek.getDate() + 6);

		this.periodThisWeek = {
			start: startOfWeek,
			end: endOfWeek,
		};

		// This month
		const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		this.periodThisMonth = {
			start: startOfMonth,
			end: endOfMonth,
		};

		// This year
		this.periodThisYear = {
			start: new Date(today.getFullYear(), 0, 1),
			end: new Date(today.getFullYear() + 1, 0, 1),
		};
	}
}
